<template>
  <div class="digital-selection">
    <label>口播文稿</label>
    <el-input v-model="text" type="textarea" :rows="4" maxlength="4000" show-word-limit :disabled="busy" placeholder="确认视频中实际朗读的内容" />
    <p>模特：{{ person ? person.name : '未选择' }}　声音：{{ voice ? voice.name : '未选择' }}</p>
    <digital-human-audio-preview v-if="voice && voice.previewUrl" :src="voice.previewUrl" />
    <el-button size="small" :disabled="busy || bgUploading" @click="visible = true">选择模特和声音</el-button>
    <section v-if="person" class="background-choice">
      <label>视频背景</label>
      <template v-if="canSetBackground">
        <el-radio-group v-model="backgroundMode" :disabled="busy || bgUploading">
          <el-radio label="original">保留原形象背景</el-radio>
          <el-radio label="color">使用纯色背景</el-radio>
          <el-radio label="image">上传背景图片</el-radio>
        </el-radio-group>
        <small>该模特支持换背景，请明确选择。保留原背景不会额外添加背景图片。</small>
        <el-color-picker v-if="backgroundMode === 'color'" v-model="bgColor" :disabled="busy" color-format="hex" />
        <el-upload v-if="backgroundMode === 'image'" :action="uploadAction" name="img" :show-file-list="false"
          :data="{ merchant_guid: $store.state.merchantGuid }" :disabled="busy || bgUploading"
          :before-upload="beforeBackgroundUpload" :on-success="backgroundUploaded" :on-error="backgroundUploadFailed">
          <el-button size="small" :loading="bgUploading">{{ bgSrcUrl ? '更换背景图片' : '上传 JPG / PNG 背景' }}</el-button>
        </el-upload>
        <img v-if="backgroundMode === 'image' && bgSrcUrl" :src="bgSrcUrl" class="background-preview" alt="待确认的视频背景" />
        <small v-if="backgroundMode === 'image'">复用现有图片上传，最大 20MB；推荐竖版 1080×1920。</small>
      </template>
      <small v-else>此形象未确认支持换背景，将沿用原形象背景。</small>
    </section>
    <el-button size="small" type="primary" :disabled="!canConfirm" :loading="busy" @click="confirm">确认文稿与选择，查看费用</el-button>
    <small>此步骤不扣点。下一步核对真实费用，确认生成后才提交。</small>
    <el-dialog title="选择数字人模特和声音" :visible.sync="visible" width="800px" append-to-body :close-on-click-modal="false">
      <el-tabs v-model="tab">
        <el-tab-pane label="模板数字人" name="public" />
        <el-tab-pane label="我的定制" name="owned" />
      </el-tabs>
      <div class="avatar-scroll"><digital-human-avatar-grid :avatars="avatars" :value="personId" @select="selectAvatar" /></div>
      <div class="voice-choice">
        <label>声音</label>
        <el-select v-model="voiceId" filterable placeholder="选择声音并试听">
          <el-option v-for="item in voices" :key="item.audioManId" :label="item.name" :value="item.audioManId" />
        </el-select>
        <digital-human-audio-preview v-if="voice && voice.previewUrl" :src="voice.previewUrl" />
        <small v-else>该声音暂无试听样例</small>
      </div>
      <span slot="footer"><el-button type="primary" :disabled="!person || !voice" @click="visible = false">使用此模特和声音</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import DigitalHumanAvatarGrid from '../layout-digital-human/components/digital-human-avatar-grid.vue'
import DigitalHumanAudioPreview from '../layout-digital-human/components/digital-human-audio-preview.vue'
import config from '@/apis/config'
export default {
  components: { DigitalHumanAvatarGrid, DigitalHumanAudioPreview },
  props: { media: { type: Object, required: true }, busy: Boolean },
  data() { return { text: this.media.input.text || '', personId: this.media.input.personId || '', voiceId: this.media.input.audioManId || '', visible: false, tab: 'public',
    backgroundMode: '', bgColor: '#DDE7F3', bgSrcUrl: '', bgUploading: false, bgUploadPerson: '' } },
  computed: {
    persons() { return this.media.options && this.media.options.persons || [] },
    voices() { return this.media.options && this.media.options.voices || [] },
    avatars() { return this.persons.filter(p => p.source === this.tab) },
    person() { return this.persons.find(p => p.personId === this.personId) },
    voice() { return this.voices.find(v => v.audioManId === this.voiceId) },
    canSetBackground() {
      const person = this.person
      return Boolean(person && person.isSupportRemoveBg && (person.source !== 'public'
        || (person.figures && person.figures[0] && person.figures[0].bgReplace === true)))
    },
    uploadAction() { return `${config.baseUrl}user/api.userinfo/uploadImg` },
    canConfirm() {
      const backgroundReady = !this.canSetBackground || this.backgroundMode === 'original'
        || (this.backgroundMode === 'color' && /^#[a-f0-9]{6}$/i.test(this.bgColor || ''))
        || (this.backgroundMode === 'image' && Boolean(this.bgSrcUrl))
      return !this.busy && !this.bgUploading && backgroundReady && this.text.trim().length > 0 && this.text.length <= 4000 && Boolean(this.person && this.voice)
    }
  },
  methods: {
    selectAvatar(id) {
      // 不把前一个模特的背景误用到不支持换背景的模特。
      if (id !== this.personId) { this.bgSrcUrl = ''; this.backgroundMode = ''; this.bgUploadPerson = '' }
      this.personId = id
      const person = this.persons.find(p => p.personId === id)
      if (person && this.voices.some(v => v.audioManId === person.defaultAudioManId)) this.voiceId = person.defaultAudioManId
      if (!this.canSetBackground) this.backgroundMode = 'original'
    },
    beforeBackgroundUpload(file) {
      if (!this.canSetBackground || !['image/jpeg', 'image/png'].includes(file.type) || file.size >= 20 * 1024 * 1024) {
        this.$message.error('请选择小于 20MB 的 JPG / PNG 背景图片'); return false
      }
      this.bgUploadPerson = this.personId; this.bgUploading = true; return true
    },
    backgroundUploaded(response) {
      this.bgUploading = false
      if (this.personId !== this.bgUploadPerson || !this.canSetBackground) return
      try {
        const url = new URL(response.data)
        if (response.code !== 0 || url.protocol !== 'https:' || url.username || url.password) throw new Error()
        this.bgSrcUrl = response.data
      } catch (_) { this.$message.error('背景图上传失败，请重试') }
    },
    backgroundUploadFailed() { this.bgUploading = false; this.$message.error('背景图上传失败，请重试') },
    // 选择与文稿都可修改；这里只提交配置，付款批准必须由下一张服务端费用卡单独完成。
    confirm() {
      if (!this.canConfirm) return
      const backgroundMode = this.canSetBackground ? this.backgroundMode : 'original'
      this.$emit('configure', { text: this.text.trim(), personId: this.personId, audioManId: this.voiceId, backgroundMode,
        ...(backgroundMode === 'color' ? { bgColor: this.bgColor } : {}), ...(backgroundMode === 'image' ? { bgSrcUrl: this.bgSrcUrl } : {}) })
    }
  }
}
</script>
<style scoped>
.digital-selection label{display:block;margin:10px 0;font-weight:600}.digital-selection small{display:block;margin:12px 0;color:#909399}.digital-selection audio{vertical-align:middle;max-width:100%}.avatar-scroll{max-height:390px;overflow:auto;padding:4px}.voice-choice{margin-top:20px}.voice-choice audio{display:block;margin-top:12px}
.background-choice{margin:12px 0;padding:12px;border:1px solid #eee;border-radius:8px}.background-preview{display:block;max-width:160px;max-height:180px;margin-top:10px;object-fit:contain}
</style>
